export default __webpack_public_path__ + "static/media/50.aac1219b.png";